import { useMemo, useState } from 'react'
import { useListEquipmentsQuery } from '../../../store/equipments/equipments.api'
import SelectField, { Option } from '../../select-field/select-field.component'
import { SelectChangeEvent, Stack, Typography } from '@mui/material'
import { EquipmentType } from '../../../store/equipments/equipments.types'

const DriverTrackingForm = () => {
  const [selectedTractor, setSelectedTractor] = useState('')
  const [selectedTrailer, setSelectedTrailer] = useState('')

  const { data: equipmentsData } = useListEquipmentsQuery()

  const tractorOptions: Option[] = useMemo(() => {
    if (!equipmentsData) return []

    return equipmentsData
      .filter((equipment) => equipment?.equipmentType === 'TRACTOR')
      .map((equipment) => ({
        label: equipment?.unitNumber,
        value: equipment?.equipmentId.toString(),
      }))
  }, [equipmentsData])

  const trailerOptions: Option[] = useMemo(() => {
    if (!equipmentsData) return []

    return equipmentsData
      .filter((equipment) => equipment?.equipmentType === 'TRAILER')
      .map((equipment) => ({
        label: equipment?.unitNumber,
        value: equipment?.equipmentId.toString(),
      }))
  }, [equipmentsData])

  const handleChange = (
    event: SelectChangeEvent<unknown>,
    type: EquipmentType
  ) => {
    switch (type) {
      case 'TRACTOR':
        setSelectedTractor(event.target.value as string)
        return
      case 'TRAILER':
        setSelectedTrailer(event.target.value as string)
        return
      default:
        setSelectedTractor(event.target.value as string)
        return
    }
  }

  return (
    <Stack
      spacing={4}
      p={2}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Stack minWidth={{ xs: 150, md: 200, lg: 250 }} spacing={1}>
        <Typography>Select Tractor</Typography>
        <SelectField
          options={tractorOptions}
          label="Select Tractor"
          value={selectedTractor === '' ? 'Select Tractor' : selectedTractor}
          onChange={(event) => handleChange(event, 'TRACTOR')}
          labeldirection="column"
          hideLabel
          sx={{ width: { xs: 150, md: 200, lg: 250 } }}
        />
      </Stack>
      <Stack minWidth={{ xs: 150, md: 200, lg: 250 }} spacing={1}>
        <Typography>Select Trailer</Typography>
        <SelectField
          options={trailerOptions}
          label="Select Trailer"
          value={selectedTrailer === '' ? 'Select Trailer' : selectedTrailer}
          onChange={(event) => handleChange(event, 'TRAILER')}
          labeldirection="column"
          hideLabel
          sx={{ width: { xs: 150, md: 200, lg: 250 } }}
        />
      </Stack>
    </Stack>
  )
}

export default DriverTrackingForm
